import { useEffect } from "react";
import { CalendarCheck, ExternalLink } from "lucide-react";

const CALENDLY_URL = "https://calendly.com/sozosglobal";

export default function CalendlyEmbed() {
  useEffect(() => {
    const id = "calendly-widget-script";
    if (document.getElementById(id)) return;
    const script = document.createElement("script");
    script.id = id;
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section data-testid="calendly-section" id="book" className="bg-slate-50 border-y border-slate-200">
      <div className="sozos-container section-pad">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <p className="eyebrow">Direct Booking</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0A1F44] mt-3 tracking-tight leading-[1.05]">
              Pick a time that works for your team.
            </h2>
            <p className="text-slate-600 mt-5 text-base md:text-lg leading-relaxed">
              Skip the back-and-forth. Schedule a 30-minute growth consultation with a Sozos
              strategist. We&apos;ll come prepared with a quick view on your ICP, market, and
              recommended next steps.
            </p>
            <ul className="mt-7 space-y-3 text-sm text-slate-700">
              <li className="flex items-start gap-3">
                <CalendarCheck className="w-4 h-4 mt-0.5 text-[#1E40AF]" />
                <span>30 minutes · zero obligation</span>
              </li>
              <li className="flex items-start gap-3">
                <CalendarCheck className="w-4 h-4 mt-0.5 text-[#1E40AF]" />
                <span>Get a custom 90-day revenue plan</span>
              </li>
              <li className="flex items-start gap-3">
                <CalendarCheck className="w-4 h-4 mt-0.5 text-[#1E40AF]" />
                <span>Speak directly with a senior strategist</span>
              </li>
            </ul>
            <a
              data-testid="calendly-external-link"
              href={CALENDLY_URL}
              target="_blank"
              rel="noreferrer"
              className="btn-secondary mt-8"
            >
              Open in new tab <ExternalLink className="w-4 h-4" />
            </a>
          </div>

          <div className="lg:col-span-7">
            <div
              data-testid="calendly-inline-widget"
              className="calendly-inline-widget bg-white border border-slate-200 rounded-md overflow-hidden"
              data-url={CALENDLY_URL}
              style={{ minWidth: "320px", height: "720px" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
